import React, {useEffect, useState} from 'react';
import cl from "./FormCheckboxGrid.module.css";
import {FormControlLabel, FormHelperText} from "@mui/material";
import CheckboxV2 from "../components/CheckboxV2/CheckboxV2";
import FormControlCaption from "./FormControlCaption";

// принимает набор итемов в формате { id:int, label:string, checked:bool }, возвращает их же в таком же формате (с измененными checked)
const FormCheckboxGrid = ({
                                label,
                                initItems,
                                widthLimit,
                                controlRef,
                                onChange,
                                tipText,
                                preExtraItem, // {label, checked, onChange}
                                postExtraItem, // {label, checked, onChange}
                                readOnly,
                            }) => {

    const [items, setItems] = useState([...initItems]);
    const [preExtraItemChecked, setPreExtraItemChecked] = useState(preExtraItem?.checked ?? false);
    const [postExtraItemChecked, setPostExtraItemChecked] = useState(postExtraItem?.checked ?? false);
    const [errorMessage, setErrorMessage] = useState("");

    const correctedWidthLimit = widthLimit === undefined ? 10000 : widthLimit;

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                getItems: () => items,
                getCheckedIds: getCheckedIds,
                setErrorMessage: setErrorMessage,
                getPreExtraItemChecked: () => preExtraItemChecked,
                getPostExtraItemChecked: () => postExtraItemChecked,
            };
        }
    })

    function getCheckedIds() {
        return items.filter(x => x.checked).map(x => x.id);
    }

    return (
        <div className={cl.main}>
            <FormControlCaption
                text={label}
                tipText={tipText}
            />
            {preExtraItem && <Item
                label={preExtraItem.label}
                extraInfoText={preExtraItem.extraInfoText}
                checked={preExtraItemChecked}
                setChecked={(value) => {
                    setPreExtraItemChecked(value);
                    if (preExtraItem.onChange)
                        preExtraItem.onChange(value);
                }}
                readOnly={readOnly}
            />}
            <div className={cl.gridArea} style={{
                width: `min(${correctedWidthLimit}px, 100%)`,
            }}>
                {items.map(item => <Item
                    key={item.id}
                    label={item.label}
                    extraInfoText={item.extraInfoText}
                    checked={item.checked}
                    setChecked={checked => {
                        const newItems = [...items];
                        const itemIndex = items.indexOf(item);
                        newItems[itemIndex].checked = checked;
                        setItems(newItems);
                        if (errorMessage)
                            setErrorMessage("")
                        if (onChange)
                            onChange(newItems);
                    }}
                    readOnly={readOnly}
                />)}
            </div>
            {postExtraItem && <Item
                label={postExtraItem.label}
                extraInfoText={postExtraItem.extraInfoText}
                checked={postExtraItemChecked}
                setChecked={(value) => {
                    setPostExtraItemChecked(value);
                    if (postExtraItem.onChange)
                        postExtraItem.onChange(value);
                }}
                readOnly={readOnly}
            />}
            {errorMessage &&
                <FormHelperText error sx={{marginLeft: "14px", marginTop: "0px"}}>{errorMessage}</FormHelperText>}
        </div>
    );
};

const Item = ({label, checked, setChecked, extraInfoText, readOnly}) => {
    return <div className={cl.item}>
        <FormControlLabel
            control={<CheckboxV2
                iconFillColor={readOnly ? "#ffff0018" : undefined}
                disabled={readOnly}
                checked={checked}
                onChange={e => {
                    setChecked(e.target.checked);
                }}
            />}
            label={<>
                <span className={cl.itemLabel} style={{marginBottom: "0"}}>{label}</span>
                {extraInfoText && <span className={cl.itemExtraInfo}>{extraInfoText}</span>}
            </>}
            disableTypography
        />
    </div>;
}

export default FormCheckboxGrid;